export const STOREFRONT_PATH_PREFIX = "/storefront/pages/by-path";
